var _rect, _rect2, _rect3, _animateMotion, _animateMotion2, _animateMotion3, _animateMotion4, _animateMotion5, _animateMotion6, _animateMotion7, _animateMotion8, _animateMotion9, _animateMotion10, _animateMotion11, _animateMotion12, _animateMotion13, _animateMotion14, _animateMotion15, _animateMotion16, _animateMotion17, _animateMotion18, _animateMotion19, _animateMotion20, _path, _clipPath, _animate, _animate2, _animate3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFirewall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 400 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "PfadData",
    d: "M41.606,54.204L367.826,54.204",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "router",
    transform: "matrix(0.099027,0,0,0.099027,152.844,48.9803)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-256.064,-256.064)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 423.896,
    y: 189.336,
    width: 16,
    height: 87.632
  })), /*#__PURE__*/React.createElement("rect", {
    x: 403.904,
    y: 380.128,
    width: 56,
    height: 45.992,
    style: {
      fill: "rgb(147,147,147)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M463.248,180.08C430.04,153.024 402.24,178.568 401.08,179.664L390.008,168.112C403.304,155.328 437.84,138.76 473.36,167.672L463.248,180.08Z",
    style: {
      fill: "rgb(170,170,170)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.536,154.6C428.856,111.696 384.888,152.432 383.048,154.176L371.968,142.632C372.52,142.104 427.8,90.232 491.64,142.192L481.536,154.6Z",
    style: {
      fill: "rgb(170,170,170)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.896,129.408C427.488,68.832 365.488,126.496 362.88,128.984L351.8,117.44C377.288,92.928 443.552,61.272 512,117L501.896,129.408Z",
    style: {
      fill: "rgb(170,170,170)",
      fillRule: "nonzero"
    }
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 72.064,
    y: 189.336,
    width: 16,
    height: 87.632
  })), /*#__PURE__*/React.createElement("rect", {
    x: 52.096,
    y: 380.128,
    width: 56,
    height: 45.992,
    style: {
      fill: "rgb(147,147,147)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M111.448,180.08C78.24,153.024 50.44,178.568 49.28,179.664L38.208,168.112C51.496,155.328 86.04,138.76 121.56,167.672L111.448,180.08Z",
    style: {
      fill: "rgb(170,170,170)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.736,154.6C77.056,111.696 33.088,152.432 31.248,154.176L20.168,142.632C20.72,142.104 76,90.232 139.84,142.192L129.736,154.6Z",
    style: {
      fill: "rgb(170,170,170)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.096,129.408C75.696,68.832 13.68,126.496 11.08,128.984L0,117.44C25.488,92.928 91.76,61.272 160.2,117L150.096,129.408Z",
    style: {
      fill: "rgb(170,170,170)",
      fillRule: "nonzero"
    }
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.128,
    y: 267.52,
    width: 512,
    height: 122.64
  })), /*#__PURE__*/React.createElement("rect", {
    x: 49.408,
    y: 319.648,
    width: 32,
    height: 8,
    style: {
      fill: "rgb(229,9,20)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.648,
    y: 319.648,
    width: 32,
    height: 8,
    style: {
      fill: "rgb(147,147,147)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 139.888,
    y: 319.648,
    width: 32,
    height: 8,
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.624,353.032L340.464,307.456L349.32,307.456L353.648,328.144C354.8,333.688 355.872,339.512 356.624,344.04L356.76,344.04C357.504,339.232 358.792,333.832 360.072,328.08L365.008,307.456L373.736,307.456L378.264,328.416C379.416,333.832 380.36,338.904 381.04,343.84L381.176,343.84C381.992,338.832 383.064,333.632 384.288,328.08L389.024,307.456L397.48,307.456L385.24,353.032L376.32,353.032L371.584,331.592C370.432,326.384 369.624,322.056 369.08,317.12L368.944,317.12C368.128,321.984 367.256,326.376 365.904,331.592L360.624,353.032L351.624,353.032Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.008,310.904C410.008,313.4 408.184,315.368 405.272,315.368C402.496,315.368 400.68,313.408 400.68,310.904C400.68,308.336 402.568,306.376 405.344,306.376C408.184,306.368 409.944,308.328 410.008,310.904ZM401.144,353.032L401.144,320.096L409.536,320.096L409.536,353.032L401.144,353.032Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.784,307.456L445.088,307.456L445.088,314.288L427.096,314.288L427.096,326.864L443.872,326.864L443.872,333.696L427.096,333.696L427.096,353.04L418.784,353.04L418.784,307.456Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.216,310.904C460.216,313.4 458.392,315.368 455.48,315.368C452.704,315.368 450.888,313.408 450.888,310.904C450.888,308.336 452.776,306.376 455.552,306.376C458.392,306.368 460.152,308.328 460.216,310.904ZM451.352,353.032L451.352,320.096L459.744,320.096L459.744,353.032L451.352,353.032Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Firewall",
    transform: "matrix(1.21903,0,-1.73472e-18,1.32016,-14.0841,-20.6928)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.417108,0,0,0.556325,117.792,20.7126)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.817,37.347C217.817,35.706 215.893,34.374 213.523,34.374L187.964,34.374C185.594,34.374 183.67,35.706 183.67,37.347L183.67,43.292C183.67,44.933 185.594,46.264 187.964,46.264L213.523,46.264C215.893,46.264 217.817,44.933 217.817,43.292L217.817,37.347Z",
    style: {
      fill: "rgb(141,56,38)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.417108,0,0,0.556325,132.779,20.8536)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.817,37.347C217.817,35.706 215.893,34.374 213.523,34.374L187.964,34.374C185.594,34.374 183.67,35.706 183.67,37.347L183.67,43.292C183.67,44.933 185.594,46.264 187.964,46.264L213.523,46.264C215.893,46.264 217.817,44.933 217.817,43.292L217.817,37.347Z",
    style: {
      fill: "rgb(141,56,38)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.417108,0,0,0.556325,147.651,20.5193)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.817,37.347C217.817,35.706 215.893,34.374 213.523,34.374L187.964,34.374C185.594,34.374 183.67,35.706 183.67,37.347L183.67,43.292C183.67,44.933 185.594,46.264 187.964,46.264L213.523,46.264C215.893,46.264 217.817,44.933 217.817,43.292L217.817,37.347Z",
    style: {
      fill: "rgb(141,56,38)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.417108,0,0,0.556325,133.094,35.3561)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.817,37.347C217.817,35.706 215.893,34.374 213.523,34.374L187.964,34.374C185.594,34.374 183.67,35.706 183.67,37.347L183.67,43.292C183.67,44.933 185.594,46.264 187.964,46.264L213.523,46.264C215.893,46.264 217.817,44.933 217.817,43.292L217.817,37.347Z",
    style: {
      fill: "rgb(141,56,38)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.417108,0,0,0.556325,147.965,35.0218)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.817,37.347C217.817,35.706 215.893,34.374 213.523,34.374L187.964,34.374C185.594,34.374 183.67,35.706 183.67,37.347L183.67,43.292C183.67,44.933 185.594,46.264 187.964,46.264L213.523,46.264C215.893,46.264 217.817,44.933 217.817,43.292L217.817,37.347Z",
    style: {
      fill: "rgb(141,56,38)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.417108,0,0,0.556325,118.106,35.4086)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.817,37.347C217.817,35.706 215.893,34.374 213.523,34.374L187.964,34.374C185.594,34.374 183.67,35.706 183.67,37.347L183.67,43.292C183.67,44.933 185.594,46.264 187.964,46.264L213.523,46.264C215.893,46.264 217.817,44.933 217.817,43.292L217.817,37.347Z",
    style: {
      fill: "rgb(141,56,38)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.417108,0,0,0.556325,141.423,27.8148)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.817,37.347C217.817,35.706 215.893,34.374 213.523,34.374L187.964,34.374C185.594,34.374 183.67,35.706 183.67,37.347L183.67,43.292C183.67,44.933 185.594,46.264 187.964,46.264L213.523,46.264C215.893,46.264 217.817,44.933 217.817,43.292L217.817,37.347Z",
    style: {
      fill: "rgb(141,56,38)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.417108,0,0,0.556325,156.642,27.6197)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.817,37.347C217.817,35.706 215.893,34.374 213.523,34.374L187.964,34.374C185.594,34.374 183.67,35.706 183.67,37.347L183.67,43.292C183.67,44.933 185.594,46.264 187.964,46.264L213.523,46.264C215.893,46.264 217.817,44.933 217.817,43.292L217.817,37.347Z",
    style: {
      fill: "rgb(141,56,38)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.417108,0,0,0.556325,110.984,28.0099)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.817,37.347C217.817,35.706 215.893,34.374 213.523,34.374L187.964,34.374C185.594,34.374 183.67,35.706 183.67,37.347L183.67,43.292C183.67,44.933 185.594,46.264 187.964,46.264L213.523,46.264C215.893,46.264 217.817,44.933 217.817,43.292L217.817,37.347Z",
    style: {
      fill: "rgb(141,56,38)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.417108,0,0,0.556325,126.179,28.0082)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.817,37.347C217.817,35.706 215.893,34.374 213.523,34.374L187.964,34.374C185.594,34.374 183.67,35.706 183.67,37.347L183.67,43.292C183.67,44.933 185.594,46.264 187.964,46.264L213.523,46.264C215.893,46.264 217.817,44.933 217.817,43.292L217.817,37.347Z",
    style: {
      fill: "rgb(141,56,38)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.417108,0,0,0.556325,141.032,42.6441)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.817,37.347C217.817,35.706 215.893,34.374 213.523,34.374L187.964,34.374C185.594,34.374 183.67,35.706 183.67,37.347L183.67,43.292C183.67,44.933 185.594,46.264 187.964,46.264L213.523,46.264C215.893,46.264 217.817,44.933 217.817,43.292L217.817,37.347Z",
    style: {
      fill: "rgb(141,56,38)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.417108,0,0,0.556325,156.252,42.4489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.817,37.347C217.817,35.706 215.893,34.374 213.523,34.374L187.964,34.374C185.594,34.374 183.67,35.706 183.67,37.347L183.67,43.292C183.67,44.933 185.594,46.264 187.964,46.264L213.523,46.264C215.893,46.264 217.817,44.933 217.817,43.292L217.817,37.347Z",
    style: {
      fill: "rgb(141,56,38)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.417108,0,0,0.556325,110.593,42.8392)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.817,37.347C217.817,35.706 215.893,34.374 213.523,34.374L187.964,34.374C185.594,34.374 183.67,35.706 183.67,37.347L183.67,43.292C183.67,44.933 185.594,46.264 187.964,46.264L213.523,46.264C215.893,46.264 217.817,44.933 217.817,43.292L217.817,37.347Z",
    style: {
      fill: "rgb(141,56,38)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.417108,0,0,0.556325,125.789,42.8374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.817,37.347C217.817,35.706 215.893,34.374 213.523,34.374L187.964,34.374C185.594,34.374 183.67,35.706 183.67,37.347L183.67,43.292C183.67,44.933 185.594,46.264 187.964,46.264L213.523,46.264C215.893,46.264 217.817,44.933 217.817,43.292L217.817,37.347Z",
    style: {
      fill: "rgb(141,56,38)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Data",
    transform: "matrix(0.0436618,0,0,0.0436618,55.1733,54.0519)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-256,-256)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M449.362,8.17L449.362,438.468L394.894,460.255L416.681,8.17L449.362,8.17Z",
    style: {
      fill: "rgb(208,251,253)",
      fillRule: "nonzero"
    }
  }, _animateMotion || (_animateMotion = /*#__PURE__*/React.createElement("animateMotion", {
    id: "data",
    path: "M41.606,54.204L6367.826,54.204",
    dur: "6s",
    begin: "malware.end + 1s"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M62.638,8.17L62.638,503.83L384,503.83L416.681,449.362L416.681,8.17L62.638,8.17Z",
    style: {
      fill: "rgb(240,254,255)",
      fillRule: "nonzero"
    }
  }, _animateMotion2 || (_animateMotion2 = /*#__PURE__*/React.createElement("animateMotion", {
    path: "M41.606,54.204L6367.826,54.204",
    dur: "6s",
    begin: "malware.end + 1s"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M384,438.468L384,503.83L449.362,438.468L384,438.468Z",
    style: {
      fill: "rgb(80,209,221)",
      fillRule: "nonzero"
    }
  }, _animateMotion3 || (_animateMotion3 = /*#__PURE__*/React.createElement("animateMotion", {
    path: "M41.606,54.204L6367.826,51.204",
    dur: "6s",
    begin: "malware.end + 1s"
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 182.468,
    cy: 133.991,
    r: 8.17,
    style: {
      fill: "rgb(80,209,221)"
    }
  }, _animateMotion4 || (_animateMotion4 = /*#__PURE__*/React.createElement("animateMotion", {
    path: "M41.606,54.204L6367.826,54.204",
    dur: "6s",
    begin: "malware.end + 1s"
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 215.149,
    cy: 133.991,
    r: 8.17,
    style: {
      fill: "rgb(80,209,221)"
    }
  }, _animateMotion5 || (_animateMotion5 = /*#__PURE__*/React.createElement("animateMotion", {
    path: "M41.606,54.204L6367.826,54.204",
    dur: "6s",
    begin: "malware.end + 1s"
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 247.83,
    cy: 133.991,
    r: 8.17,
    style: {
      fill: "rgb(80,209,221)"
    }
  }, _animateMotion6 || (_animateMotion6 = /*#__PURE__*/React.createElement("animateMotion", {
    path: "M41.606,54.204L6367.826,54.204",
    dur: "6s",
    begin: "malware.end + 1s"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M449.362,0L62.638,0C58.125,0 54.468,3.658 54.468,8.17L54.468,503.83C54.468,508.342 58.125,512 62.638,512L384,512C386.167,512 388.244,511.139 389.778,509.607L455.14,444.245C456.672,442.713 457.532,440.635 457.532,438.468L457.532,8.17C457.532,3.658 453.875,0 449.362,0ZM70.809,16.34L441.192,16.34L441.192,430.297L384,430.297C379.487,430.297 375.83,433.955 375.83,438.467L375.83,495.658L70.809,495.658L70.809,16.34ZM429.638,446.638L392.17,484.106L392.17,446.638L429.638,446.638Z",
    style: {
      fillRule: "nonzero"
    }
  }, _animateMotion7 || (_animateMotion7 = /*#__PURE__*/React.createElement("animateMotion", {
    path: "M41.606,54.204L6367.826,54.204",
    dur: "6s",
    begin: "malware.end + 1s"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M215.149,430.298L160.681,430.298C156.168,430.298 152.511,433.956 152.511,438.468C152.511,442.98 156.168,446.638 160.681,446.638L215.149,446.638C219.662,446.638 223.319,442.98 223.319,438.468C223.319,433.956 219.662,430.298 215.149,430.298Z",
    style: {
      fillRule: "nonzero"
    }
  }, _animateMotion8 || (_animateMotion8 = /*#__PURE__*/React.createElement("animateMotion", {
    path: "M41.606,54.204L6367.826,54.204",
    dur: "6s",
    begin: "malware.end + 1s"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M215.149,397.617L160.681,397.617C156.168,397.617 152.511,401.275 152.511,405.787C152.511,410.299 156.168,413.957 160.681,413.957L215.149,413.957C219.662,413.957 223.319,410.299 223.319,405.787C223.319,401.275 219.662,397.617 215.149,397.617Z",
    style: {
      fillRule: "nonzero"
    }
  }, _animateMotion9 || (_animateMotion9 = /*#__PURE__*/React.createElement("animateMotion", {
    path: "M41.606,54.204L6367.826,54.204",
    dur: "6s",
    begin: "malware.end + 1s"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M302.298,364.936L160.681,364.936C156.168,364.936 152.511,368.594 152.511,373.106C152.511,377.618 156.168,381.276 160.681,381.276L302.298,381.276C306.811,381.276 310.468,377.618 310.468,373.106C310.468,368.594 306.811,364.936 302.298,364.936Z",
    style: {
      fillRule: "nonzero"
    }
  }, _animateMotion10 || (_animateMotion10 = /*#__PURE__*/React.createElement("animateMotion", {
    path: "M41.606,54.204L6367.826,54.204",
    dur: "6s",
    begin: "malware.end + 1s"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M384,332.255L193.362,332.255C188.849,332.255 185.192,335.913 185.192,340.425C185.192,344.937 188.849,348.595 193.362,348.595L384,348.595C388.513,348.595 392.17,344.937 392.17,340.425C392.17,335.913 388.513,332.255 384,332.255Z",
    style: {
      fillRule: "nonzero"
    }
  }, _animateMotion11 || (_animateMotion11 = /*#__PURE__*/React.createElement("animateMotion", {
    path: "M41.606,54.204L6367.826,54.204",
    dur: "6s",
    begin: "malware.end + 1s"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M384,299.574L226.043,299.574C221.53,299.574 217.873,303.232 217.873,307.744C217.873,312.256 221.53,315.914 226.043,315.914L384,315.914C388.513,315.914 392.17,312.256 392.17,307.744C392.17,303.233 388.513,299.574 384,299.574Z",
    style: {
      fillRule: "nonzero"
    }
  }, _animateMotion12 || (_animateMotion12 = /*#__PURE__*/React.createElement("animateMotion", {
    path: "M41.606,54.204L6367.826,54.204",
    dur: "6s",
    begin: "malware.end + 1s"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M250.553,275.064C250.553,279.576 254.21,283.234 258.723,283.234L384,283.234C388.513,283.234 392.17,279.576 392.17,275.064C392.17,270.552 388.513,266.894 384,266.894L258.723,266.894C254.21,266.894 250.553,270.552 250.553,275.064Z",
    style: {
      fillRule: "nonzero"
    }
  }, _animateMotion13 || (_animateMotion13 = /*#__PURE__*/React.createElement("animateMotion", {
    path: "M41.606,54.204L6367.826,54.204",
    dur: "6s",
    begin: "malware.end + 1s"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M193.362,283.234L226.043,283.234C230.556,283.234 234.213,279.576 234.213,275.064C234.213,270.552 230.556,266.894 226.043,266.894L193.362,266.894C188.849,266.894 185.192,270.552 185.192,275.064C185.191,279.576 188.848,283.234 193.362,283.234Z",
    style: {
      fillRule: "nonzero"
    }
  }, _animateMotion14 || (_animateMotion14 = /*#__PURE__*/React.createElement("animateMotion", {
    path: "M41.606,54.204L6367.826,54.204",
    dur: "6s",
    begin: "malware.end + 1s"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M152.511,242.383C152.511,246.895 156.168,250.553 160.681,250.553L302.298,250.553C306.811,250.553 310.468,246.895 310.468,242.383C310.468,237.871 306.811,234.213 302.298,234.213L160.681,234.213C156.168,234.213 152.511,237.871 152.511,242.383Z",
    style: {
      fillRule: "nonzero"
    }
  }, _animateMotion15 || (_animateMotion15 = /*#__PURE__*/React.createElement("animateMotion", {
    path: "M41.606,54.204L6367.826,54.204",
    dur: "6s",
    begin: "malware.end + 1s"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M158.253,194.451C158.253,189.939 154.596,186.281 150.083,186.281C145.577,186.281 141.913,182.616 141.913,178.146L142.049,146.52C142.049,142.053 140.834,137.74 138.595,133.992C140.835,130.245 142.049,125.933 142.049,121.464L142.049,89.872C142.049,85.366 145.714,81.702 150.219,81.702C154.732,81.702 158.389,78.044 158.389,73.532C158.389,69.02 154.732,65.362 150.219,65.362C136.704,65.362 125.708,76.357 125.708,89.873L125.708,121.464C125.708,123.874 124.632,126.156 122.756,127.727C120.901,129.278 119.83,131.572 119.83,133.992C119.83,136.412 120.901,138.706 122.756,140.257C124.633,141.828 125.709,144.111 125.709,146.485L125.573,178.111C125.573,191.627 136.569,202.622 150.084,202.622C154.596,202.621 158.253,198.963 158.253,194.451Z",
    style: {
      fillRule: "nonzero"
    }
  }, _animateMotion16 || (_animateMotion16 = /*#__PURE__*/React.createElement("animateMotion", {
    path: "M41.606,54.204L6367.826,54.204",
    dur: "6s",
    begin: "malware.end + 1s"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M280.079,81.702C284.585,81.702 288.249,85.367 288.249,89.872L288.249,121.463C288.249,125.93 289.465,130.243 291.704,133.992C289.464,137.743 288.249,142.064 288.249,146.553L288.385,178.11C288.385,182.616 284.72,186.28 280.215,186.28C275.702,186.28 272.045,189.938 272.045,194.45C272.045,198.962 275.702,202.62 280.215,202.62C293.73,202.62 304.726,191.625 304.726,178.074L304.59,146.517C304.59,144.108 305.666,141.825 307.543,140.254C309.397,138.702 310.468,136.407 310.468,133.989C310.468,131.571 309.397,129.276 307.542,127.724C305.665,126.153 304.589,123.87 304.589,121.461L304.589,89.872C304.589,76.356 293.593,65.361 280.078,65.361C275.565,65.361 271.908,69.019 271.908,73.531C271.908,78.044 275.566,81.702 280.079,81.702Z",
    style: {
      fillRule: "nonzero"
    }
  }, _animateMotion17 || (_animateMotion17 = /*#__PURE__*/React.createElement("animateMotion", {
    path: "M41.606,54.204L6367.826,54.204",
    dur: "6s",
    begin: "malware.end + 1s"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M128,234.213C123.487,234.213 119.83,237.871 119.83,242.383L119.83,438.468C119.83,442.98 123.487,446.638 128,446.638C132.513,446.638 136.17,442.98 136.17,438.468L136.17,242.383C136.17,237.871 132.513,234.213 128,234.213Z",
    style: {
      fillRule: "nonzero"
    }
  }, _animateMotion18 || (_animateMotion18 = /*#__PURE__*/React.createElement("animateMotion", {
    path: "M41.606,54.204L6367.826,54.204",
    dur: "6s",
    begin: "malware.end + 1s"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0436618,0,0,0.0436618,55.1733,54.0519)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-256,-256)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4A026"
    },
    d: "M345,167c32.953,0,46.333,40.047,46.333,73v100.333c0,74.375-60.292,134.667-134.667,134.667l0,0 C182.292,475,122,414.708,122,340.333V240c0-32.953,13.38-73,46.333-73H345z"
  }, _animateMotion19 || (_animateMotion19 = /*#__PURE__*/React.createElement("animateMotion", {
    id: "malware",
    path: "M41.606,54.204L4067.826,54.204",
    begin: "1s; data.end + 5s",
    dur: "4s"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CA463D"
    },
    d: "M309,200.333H204.333C185.372,200.333,170,184.961,170,166l0,0c0-39.948,32.385-72.333,72.333-72.333 H271c39.948,0,72.333,32.385,72.333,72.333l0,0C343.333,184.961,327.961,200.333,309,200.333z"
  }, _animateMotion20 || (_animateMotion20 = /*#__PURE__*/React.createElement("animateMotion", {
    id: "malware",
    path: "M41.606,54.204L4067.826,54.204",
    begin: "1s; data.end + 5s",
    dur: "4s"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M498.667,290.667H404V240c0-1.016,0.313-2.036,0.291-3.055C452.4,231.927,480,200.272,480,148.333v-12 c0-7.364-5.971-13.333-13.333-13.333s-13.333,5.969-13.333,13.333v12c0,38.399-17.005,58.821-51.885,62.167 c-6.069-27.025-20.875-50.381-45.537-55.7c-3.745-28.54-21.413-52.689-46.115-65.227c10.321-10.501,16.871-24.887,16.871-40.74V37 c0-7.364-5.971-13.333-13.333-13.333S300,29.636,300,37v11.833C300,66.203,285.536,80,268.167,80h-23 c-17.369,0-31.833-13.797-31.833-31.167V37c0-7.364-5.971-13.333-13.333-13.333S186.667,29.636,186.667,37v11.833 c0,15.853,6.549,30.239,16.871,40.741c-24.701,12.537-42.453,36.687-46.199,65.227c-24.695,5.324-39.465,28.736-45.519,55.808 c-35.759-2.96-53.153-23.403-53.153-62.276v-12c0-7.364-5.971-13.333-13.333-13.333S32,128.969,32,136.333v12 c0,52.415,27.439,84.168,76.375,88.739C108.353,238.048,108,239.025,108,240v50.667H13.333C5.971,290.667,0,296.636,0,304 c0,7.364,5.971,13.333,13.333,13.333H108v23c0,10.628,1.469,20.993,3.608,30.992C60.659,374.777,32,406.773,32,460.333v12 c0,7.364,5.971,13.333,13.333,13.333s13.333-5.969,13.333-13.333v-12c0-41.795,20.151-62.291,61.565-62.649 c22.451,53.208,75.151,90.649,136.435,90.649c61.276,0,113.971-37.432,136.425-90.629c40.519,0.784,60.241,21.283,60.241,62.629v12 c0,7.364,5.971,13.333,13.333,13.333S480,479.697,480,472.333v-12c0-53.1-28.823-85.013-78.96-88.921 c2.151-10.025,2.96-20.421,2.96-31.079v-23h94.667c7.363,0,13.333-5.969,13.333-13.333C512,296.636,506.029,290.667,498.667,290.667 z M242.333,106.667h2.833h23H271c32.532,0,59,26.468,59,59c0,11.58-9.42,21-21,21H204.333c-11.58,0-21-9.42-21-21 C183.333,133.135,209.801,106.667,242.333,106.667z M134.667,340.333V240c0-20.793,6.948-50.531,24.483-58.035 c6.627,18.368,24.56,31.368,45.184,31.368h38.333v247.521C182.333,453.891,134.667,402.501,134.667,340.333z M269.333,461.007 V213.333H309c20.624,0,37.891-13,44.517-31.368c17.535,7.504,23.816,37.241,23.816,58.035v100.333 C377.333,402.96,330.307,454.653,269.333,461.007z"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    id: "malware",
    path: "M41.606,54.204L4067.826,54.204",
    begin: "1s; data.end + 5s",
    dur: "4s"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Cloud",
    transform: "matrix(0.154715,0,0,0.154715,38.1098,48.0183)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-238.064,-238.064)"
  }, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 476.127,
    height: 476.127
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip2)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M88.72,192.388C38.476,200.564 0,244.263 0,296.779C0,355.097 47.445,402.542 105.763,402.542L238.063,402.542L238.063,73.585C165.992,73.585 104.459,123.616 88.72,192.388Z",
    style: {
      fill: "rgb(189,219,255)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.407,192.388C371.668,123.616 310.136,73.584 238.064,73.584L238.064,402.542L370.364,402.542C428.682,402.542 476.127,355.097 476.127,296.779C476.127,244.263 437.651,200.564 387.407,192.388Z",
    style: {
      fill: "rgb(155,201,255)",
      fillRule: "nonzero"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "laptop-svgrepo-com.svg",
    transform: "matrix(0.160996,0,0,0.160996,362.109,48.4879)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-217.12,-217.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.97,316.51L277.26,316.51C277.26,331.57 265.05,343.78 249.99,343.78L184.25,343.78C169.19,343.78 156.97,331.57 156.97,316.51Z",
    style: {
      fill: "rgb(102,100,93)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.24,316.51L434.24,349.21C434.24,361.31 424.43,371.12 412.33,371.12L21.91,371.12C9.81,371.12 0,361.31 0,349.21L0,316.51L156.97,316.51C156.97,331.57 169.19,343.78 184.25,343.78L249.99,343.78C265.05,343.78 277.26,331.57 277.26,316.51L434.24,316.51Z",
    style: {
      fill: "rgb(153,153,153)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.08,85.03L418.08,316.51L16.15,316.51L16.15,85.03C16.15,72.93 25.96,63.12 38.06,63.12L396.17,63.12C408.27,63.12 418.08,72.93 418.08,85.03ZM385.32,280.91L385.32,97.42L48.92,97.42L48.92,280.91L385.32,280.91Z",
    style: {
      fill: "rgb(178,177,170)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.32,97.42L385.32,280.91L189.12,280.91L269.97,97.42L385.32,97.42Z",
    style: {
      fill: "rgb(155,201,255)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.97,97.42L189.12,280.91L48.92,280.91L48.92,97.42L269.97,97.42Z",
    style: {
      fill: "rgb(189,219,255)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,8.91768,1.22129)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "222.823px",
    y: "82.339px",
    style: {
      fontFamily: "'ArialMT', 'Arial', sans-serif",
      fontSize: 11
    }
  }, "Firewall")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,117.116,0.152439)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "222.823px",
    y: "82.339px",
    style: {
      fontFamily: "'ArialMT', 'Arial', sans-serif",
      fontSize: 11
    }
  }, "Endger\xE4t")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-87.1951,1.22129)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "222.823px",
    y: "82.339px",
    style: {
      fontFamily: "'ArialMT', 'Arial', sans-serif",
      fontSize: 11
    }
  }, "Router")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-204.192,1.22129)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "222.823px",
    y: "82.339px",
    style: {
      fontFamily: "'ArialMT', 'Arial', sans-serif",
      fontSize: 11
    }
  }, "Internet")), /*#__PURE__*/React.createElement("g", {
    id: "Blocked",
    transform: "matrix(0.545282,6.72111e-33,6.72111e-33,0.545282,-405.453,-721.967)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,6.16298e-32,2.46519e-32,1,1157.7,1332.9)"
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0,
    cx: 25.3,
    cy: 88.1,
    r: 22,
    style: {
      fill: "rgb(255,59,48)"
    }
  }, _animate || (_animate = /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0; 1; 1; 1; 1; 1; 1; 1",
    begin: "malware.end - 1s",
    dur: "2s"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,6.16298e-32,2.46519e-32,1,1157.7,1332.9)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0,
    x: 14.3,
    y: 87.1,
    width: 22,
    height: 2,
    style: {
      fill: "white"
    }
  }, _animate2 || (_animate2 = /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0; 1; 1; 1; 1; 1; 1; 1",
    begin: "malware.end - 1s",
    dur: "2s"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Accept",
    transform: "matrix(0.549612,4.0647e-32,6.77449e-33,0.549612,75.651,4.36179)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0,
    d: "M298.5,66.1C286.3,66.1 276.5,75.9 276.5,88.1C276.5,100.3 286.3,110.1 298.5,110.1C310.7,110.1 320.5,100.3 320.5,88.1C320.5,75.9 310.7,66.1 298.5,66.1ZM295.5,97.5L287.8,89.8L289.2,88.4L295.5,94.7L310.8,79.4L312.2,80.8L295.5,97.5Z",
    style: {
      fill: "rgb(48,151,0)",
      fillRule: "nonzero"
    }
  }, _animate3 || (_animate3 = /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0; 1; 1; 1; 1; 1; 1; 1",
    begin: "data.begin + 3.5s",
    dur: "1.5s"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirewall);
export default __webpack_public_path__ + "static/media/Firewall.401f5a2acc1446a573886ea067bd1621.svg";
export { ForwardRef as ReactComponent };